import React, { useState } from 'react'
import { VerifyOtpScreen } from './VerifyOtpScreen'
import { OptionalOtpScreen } from './OptionalOtpScreen'

export const RiskChangeSaveFlow = (props) => {
  const [confirmRiskChanges, setConfirmRiskChanges] = useState(false)
  const [Otp, setOtp] = useState('')

  return (
    confirmRiskChanges
      ? <VerifyOtpScreen
        {...props}
        Otp={Otp}
        setOtp={setOtp}
        />
      : <OptionalOtpScreen
        {...props}
        setConfirmRiskChanges={setConfirmRiskChanges}
        setOtp={setOtp}
        />

  )
}
